<template>
  <div class="btn-about" @click="btnClickHandler()">
    <btn-blue size="small">
      <span class="text" v-html="$t('btn.about')" />
    </btn-blue>
  </div>
</template>
<script>
import BtnBlue from '@components/global/button-blue.vue'
import localeCommon from '@locales/common'

export default {
  $messages: localeCommon,
  components: {
    BtnBlue
  },
  methods: {
    btnClickHandler() {
      this.$router.push(`/${this.$route.params.lang}/about`)
      window.scrollTo(0, 0)
    }
  },
}
</script>
<style lang="scss" scoped>
.btn-about {
  width: 360px;
  height: 60px;
  margin: 0 auto;
  display: block;
  @include tap-event();
  .text {
    text-shadow: $ts-base;
  }
}
</style>